import {Component, Input, OnInit} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'app-chat-item',
  templateUrl: './chat-item.component.html',
  styleUrl: './chat-item.component.css'
})
export class ChatItemComponent implements OnInit{
  @Input() showHeader: boolean | undefined;
  @Input() name: string | undefined;
  @Input() type: string | undefined;
  @Input() message: string ='';
  @Input() buttons: any | undefined;
  @Input() url: any | undefined;
  htmlMessage: SafeHtml | undefined;
  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.htmlMessage =  this.sanitizer.bypassSecurityTrustHtml(this.message);
    console.log('Mensaje', this.message)
  }

}
